'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getAllInstructions() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/instructions')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getInstruction(instructionId, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/instructions/${instructionId}?languageId=${languageId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addInstruction(instruction) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/instructions', instruction)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateInstruction(instruction) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/instructions/${instruction.id}`, instruction)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addPage(instructionId, page) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/instructions/${instructionId}/pages`, page)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updatePage(instructionId, page) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/instructions/${instructionId}/pages/${page.id}`, page)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deletePage(instructionId, pageId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/instructions/${instructionId}/pages/${pageId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteTranslation(instructionId, translationId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `/api/instructions/${instructionId}/translations/${translationId}`
        )
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteInstruction(instructionId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/instructions/${instructionId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteInstructionContent(instructionId, instructionContentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `/api/instructions/${instructionId}/content/${instructionContentId}`
        )
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getQuestions(instructionId, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/instructions/${instructionId}/questions/${languageId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveQuestions(instructionId, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/instructions/${instructionId}/questions`, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
